import "core-js/modules/es.array.concat";
// Vendor Libs
import { applyMiddleware, createStore, compose } from 'redux';
import { createLogger } from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { reachify } from 'redux-first-history'; // Dish Tech React

import { freezer, reduxDev, styleLoader } from '@dishtech-react/utils'; // Reducers

import { getRootReducer, reduxHistoryContext } from './reducers'; // Lib App

import { routerMiddleware } from './middlewares/router-middleware';
import { getServiceMiddleware } from './middlewares/service-middleware';
import { errorMiddleware } from './middlewares/error-middleware';
import { getFormMiddleware } from './middlewares/form-middleware';
var createReduxHistory = reduxHistoryContext.createReduxHistory,
    historyMiddleware = reduxHistoryContext.routerMiddleware;
export var getStore = function getStore(config, reducers, middlewares) {
  if (reducers === void 0) {
    reducers = {};
  }

  if (middlewares === void 0) {
    middlewares = [];
  }

  var store = compose(applyMiddleware.apply(void 0, [errorMiddleware, promise, thunk, freezer, historyMiddleware, routerMiddleware, getServiceMiddleware(config), getFormMiddleware(config), createLogger({
    collapsed: true
  })].concat(middlewares)), reduxDev())(createStore)(getRootReducer(reducers, config));
  var history = reachify(createReduxHistory(store));
  return [store, history];
};

if (module.hot) {
  styleLoader();
}